module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', {
    attrs: {
      "size": _vm.size,
      "placeholder": _vm.placeholder
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onSearch
    },
    slot: "append"
  }), (_vm.keyword) ? _c('div', {
    staticClass: "clear",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.onClear
    },
    slot: "suffix"
  }, [_c('i', {
    staticClass: "el-icon-circle-close"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2957c9c0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBox.vue
// module id = 567
// module chunks = 85